module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered hidden",
    attrs: {
      "id": "profile-div"
    }
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('social', {
    attrs: {
      "socialMedia": _vm.socialMedia
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('figure', {
    staticClass: "image is-256x256 is-centered"
  }, [_c('img', {
    attrs: {
      "src": "/static/Profile2-shadow.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "title"
  }, [_vm._v("\n      Hi! My name is "), _c('strong', {
    staticClass: "is-pink"
  }, [_vm._v("Xavi Sánchez")]), _vm._v(", nice to meet you!\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "subtitle"
  }, [_c('code', [_vm._v("I'm a "), _c('strong', {
    staticClass: "is-primary"
  }, [_vm._v("Fullstack")]), _vm._v(" developer currently living in Madrid.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-646ce48a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hero/hero-body.vue
// module id = 274
// module chunks = 2